{
    "welcome": "Добро пожаловать!",
    "loginForm": {
        "title": "Вход",
        "login": "Логин / e-mail",
        "password": "Пароль",
        "forgotPassword": "Забыли пароль?",
        "enterBtn": "Войти"
    },
    "menu": {
        "schedule": "Расписание",
        "employees": "Сотрудники",
        "exchange": "Биржа смен",
        "analytics": "Аналитика",
        "settings": "Настройки"
    }
}